import React from "react";
import { Box } from "@material-ui/core";
import { useSelector } from "react-redux";

import numberFormatter from "utils/numberFormatter";

import KPIComparator from "components/visuals/KPIComparator";

import { useAppSelector } from "store";
import { selectStore, selectComparator } from "modules/customer/insights/portfolio/portfolioSlice";
import { selectors } from "modules/customer/insights/portfolio/sales/growth";

const StoreForecastYoYGrowthVsComparator = () => {
    const selectedStore = useAppSelector(selectStore);
    const selectedComparator = useAppSelector(selectComparator);
    const storeForecastYoYGrowthVsComparator = useSelector(state => selectors.storeForecastYoYGrowthVsComparator(state));
    const { loading, error, value, percentageDifference } = storeForecastYoYGrowthVsComparator;
    const label = `${selectedStore.name} forecast YOY growth vs ${selectedComparator.name}`;
    const valueFormatted = numberFormatter.toPercentage(value, 1);

    return (
        <Box data-cy="store-forecast-yoy-growth-vs-comparator">
            <KPIComparator loading={loading} error={error} label={label} value={valueFormatted} percentage={percentageDifference} />
        </Box>
    );
};

export default StoreForecastYoYGrowthVsComparator;
